<template>
  <BadgeAI
    :offset-x="20"
    :offset-y="18"
    :visible="growthBook.ai_functionals && $can('use', 'aiRequirementsFromDocument')">
    <sButton
      color="var(--white-color)"
      data-qa="btn-compare"
      icon="table"
      type="text"
      @click="openCompareTable">
      {{ $t('Tenders.Compare') }}
    </sButton>
  </BadgeAI>
</template>
<script>
import BadgeAI from 'components/common/elements/BadgeAI.vue'

/**
 * Кнопка «Порівняти»: кладе обрані пропозиції в store і відкриває сторінку порівняння
 */
export default {
  name: 'CompareTableBtn',
  methods: {
    openCompareTable() {
      this.$store.commit('setCompareItems', { tenderId: this.tenderId, items: this.elements })
      this.$router.push(this.route)
    },
  },
  components: {
    BadgeAI,
  },
  props: {
    elements: {
      type: Array,
      required: true
    },
    tenderId: {
      type: [Number, String],
      default: null
    },
    /** { name, params, query? } маршруту сторінки порівняння */
    route: {
      type: Object,
      required: true
    },
  },
}
</script>
